import React, { Component } from 'react';

import { Panel } from 'primereact/panel';

import Server from './../Server.js'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { confirmAlert } from 'react-confirm-alert';
import { connect } from 'react-redux';
import { Loader } from 'rsuite';
import DatePicker from 'react-datepicker2';
import { Toast } from "primereact/toast";


class Company_Actions extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();


    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetAction = this.SetAction.bind(this);
    this.GetAction = this.GetAction.bind(this);
    this.delAction = this.delAction.bind(this);

    this.state = {
      name: "",
      type: "1",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      latinName: "",
      IntroducedPrice: "",
      creditAmount: "",
      debtorAmount: "",
      edit: false

    }

    this.toast = React.createRef();

  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        user: response.data.authData.name,
        username: response.data.authData.username,
        loading: 0
      })
      that.Server.send("AdminApi/ShopInformation", { ShopId: response.data.authData.shopId }, function (response) {
        that.setState({
          isMainShop: response.data.result[0]?.main,
          tokenId: response.data.result[0]?.tokenId
        })


      }, function (error) {

      })

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  SetAction() {
    let that = this;
    if(!this.state.Date.local("fa"))
      return;
   if(!this.state.StartTime || !this.state.EndTime){
        that.toast.current.show({severity:'warn', summary: '', detail: "ساعت شروع و پایان را وارد کنید" , life: 3000});
        return;
    }
    if(this.state.StartTime.indexOf(":") == -1 || this.state.StartTime.length != 5 || this.state.EndTime.indexOf(":") == -1 || this.state.EndTime.length != 5 ){
      that.toast.current.show({severity:'warn', summary: '', detail: "فرمت ساعت شروع و پایان نادرست است" , life: 3000});
      return;
  }
    let param = {
      _id: this.state.selectedId,
      type: this.state.type,
      desc: this.state.desc,
      StartTime: this.state.StartTime,
      EndTime: this.state.EndTime,
      System: this.state.System,
      username:this.state.username,
      name:this.state.user,
      tokenId:this.state.tokenId,
      Date:this.state.Date.local("fa").format("jYYYY/jM/jD")
    };
   
    
    this.setState({
      loading: 1
    })
    this.setState({
      HasErrorForMaps: null
    })
    let SCallBack = function (response) {
      if(response.data.error){
        that.setState({
          loading: 0
        })
        that.toast.current.show({severity:'warn', summary: '', detail:response.data.error[0], life: 3000});

        return;
      }
      that.onHideFormsDialog();
      that.GetAction();
      that.setState({
        loading: 0
      })
     that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
      that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
    }
    this.Server.send("CompanyApi/setUserAction", param, SCallBack, ECallBack)
  }
  CreateForm() {

    this.setState({
      visibleManageAction: true,
      desc: '',
      type: '',
      StartTime: '',
      EndTime: '',
      System: '',
      _id:null
    })

  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageAction: false,
      selectedId: null
    });

  }
  onHideMapsDialog(event) {
    this.setState({
      visibleManageMaps: false,
      HasErrorForMaps: null
    });

  }
  selectedComponentChange(value) {
    let that = this;
    
    this.setState({
      edit: true,
      visibleManageAction: true,
      StartTime: value.StartTime,
      EndTime: value.EndTime,
      type: value.type,
      desc: value.desc,
      System: value.System,
      type: value.type,
      selectedId: value._id
    })
  }
  GetAction() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      Date: this.state.Date.local("fa").format("jYYYY/jM/jD"),
      username:this.state.username,
      tokenId:this.state.tokenId
    };
    this.setState({
      loading: 1,
      visibleManageAction:false
    })
    let SCallBack = function (response) {
      that.setState({
        GridData: response.data.result
      })
      that.setState({
        loading: 0
      })
    };
    let ECallBack = function (error) {
      console.log(error)
      that.setState({
        loading: 0
      })
    }
    this.Server.send("CompanyApi/getUserAction", param, SCallBack, ECallBack)
  }
  delAction(rowData) {
    this.setState({
      visibleManageAction: false
    })
    confirmAlert({
      title: <span className="yekan">حذف ردیف</span>,
      message: <span className="yekan">  آیا از حذف مطمئنید  </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: rowData._id,
              del: 1
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0
              })
              that.GetAction();
             that.toast.current.show({severity:'success', summary: '', detail:'عملیات با موفقیت انجام شد', life: 3000});
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0
              })
              that.toast.current.show({severity:'error', summary: 'خطای سرور', detail:'عملیات انجام نشد', life: 3000});
            }
            this.Server.send("CompanyApi/setUserAction", param, SCallBack, ECallBack)

          }
        },
        {
          label: <span className="yekan">خیر </span>
        }
      ]
    });

  }

  render() {
    const footer = (
      <div>
        <button className="btn btn-primary irsans" onClick={this.SetAction} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> اعمال </button>

      </div>
    );

    const delTemplate = (rowData, props) => {
      return <i className="fa fa-times" style={{ cursor: 'pointer' }} aria-hidden="true" onClick={() => this.delAction(rowData)}></i>;
    }
    return (

      <div style={{ direction: 'rtl' }}>
        {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
        <div className="row justify-content-center mt-2">

          <Toast ref={this.toast} position="top-left" style={{ fontFamily: 'YekanBakhFaBold', textAlign: 'right' }} />

          <div className="col-12" style={{ background: '#fff' }}>
            <Panel header="مشاهده کارکردها" style={{  textAlign: 'right', marginBottom: 50, fontFamily: 'yekan' }}>

        <div className="row">


          <div className="col-12" style={{ background: '#fff' }}>
            <div className="row" style={{ alignItems: 'baseline' }} >
              <div className="col-md-3 col-12">
                <DatePicker
                  onChange={value => this.setState({ Date: value })}
                  value={this.state.Date}
                  isGregorian={false}
                  timePicker={false}
                  placeholder="تاریخ روز"

                /></div>
              <div className="col-md-3 col-12" style={{ textAlign: 'center' }}>
                <button className="btn btn-primary irsans" onClick={this.GetAction} disabled={!this.state.Date} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>جستجو</button>
              </div>
              <div className="col-md-6 col-12" style={{ textAlign: 'center' }}>
                <button className="btn btn-info irsans" onClick={this.CreateForm} disabled={!this.state.Date} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}>ثبت</button>
              </div>

            </div>
            <div className="section-title " style={{ textAlign: 'right' }}><span className="title IRANYekan" style={{ fontSize: 17, color: 'gray' }} >کارکردهای روز</span></div>

            <DataTable responsive value={this.state.GridData} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => this.selectedComponentChange(e.value)}>
              <Column field="StartTime" header="تاریخ شروع" className="irsans" style={{ textAlign: "right" }} />

              <Column field="EndTime" header="تاریخ پایان" className="irsans" style={{ textAlign: "right" }} />
              <Column field="System" header="سیستم" className="irsans" style={{ textAlign: "right" }} />

              <Column field="type" header="نوع" className="irsans" style={{ textAlign: "right" }} />
              <Column field="desc" header="توضیح" className="irsans" style={{ textAlign: "right" }} />

              <Column field="del" body={delTemplate} header="حذف" className="irsans" style={{ textAlign: "right" }} />
            </DataTable>
          </div>

        </div>


        <Dialog header={this.state.selectedId ? "اصلاح" : "ثبت کارکرد"} visible={this.state.visibleManageAction} footer={footer} minY={70} onHide={this.onHideFormsDialog} maximizable={true} maximized={false}>
          <form>

            <div className="row">
              <div className="col-lg-3">
                <div className="group">
                  <input className="form-control irsans" placeholder='00:00' autoComplete="off" type="text" value={this.state.StartTime} name="StartTime" onChange={(event) => this.setState({ StartTime: event.target.value })} required="true" />
                  <label>ساعت شروع</label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="group">
                  <input className="form-control irsans" placeholder='00:00' autoComplete="off" type="text" value={this.state.EndTime} name="EndTime" onChange={(event) => this.setState({ EndTime: event.target.value })} required="true" />
                  <label>ساعت پایان</label>
                </div>
              </div>

              <div className="col-lg-3">
                <label className="labelNoGroup irsans">سیستم</label>
                <select className="form-control irsans" value={this.state.System} name="System" onChange={(event) => this.setState({ System: event.target.value })} style={{ marginBottom: 20 }} >
                  <option value=""></option>

                  <option value="قرض الحسنه">قرض الحسنه</option>
                  <option value="آژانس">آژانس</option>
                </select>
              </div>

              <div className="col-lg-3">
                <label className="labelNoGroup irsans">نوع کارکرد</label>
                <select className="form-control irsans" value={this.state.type} name="type" onChange={(event) => this.setState({ type: event.target.value })} style={{ marginBottom: 20 }} >
                  <option value=""></option>
                  <option value="برنامه نویسی">برنامه نویسی</option>
                  <option value="بررسی و تحلیل">بررسی و تحلیل</option>
                  <option value="طراحی ui">طراحی ui</option>
                  <option value="ارتباط با مشتریان">ارتباط با مشتریان</option>

                  <option value="ثبت و ویرایش اطلاعات">ثبت و ویرایش اطلاعات</option>
                  <option value="ماموریت درون شهری">ماموریت درون شهری</option>
                  <option value="فاقد کار">فاقد کار</option>
                </select>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <input className="form-control irsans" autoComplete="off" type="text" value={this.state.desc} name="desc" onChange={(event) => this.setState({ desc: event.target.value })} required="true" />
                  <label>توضیح</label>
                </div>
              </div>





            </div>
          </form>
        </Dialog>

      </Panel>
      </div>
      </div>
      </div>




    )
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  }
}
export default connect(mapStateToProps)(Company_Actions);
